// 统一 localStorage 封装：带前缀、JSON 序列化、异常兜底
const PREFIX = 'jxab:'

export const storage = {
  get(key, defaultValue = null) {
    try {
      const raw = window.localStorage.getItem(PREFIX + key)
      return raw === null ? defaultValue : JSON.parse(raw)
    } catch {
      return defaultValue
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(PREFIX + key, JSON.stringify(value))
    } catch {
      // 无法持久化时仍可使用当前页面的内存登录态。
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(PREFIX + key)
    } catch {
      // clearAuth 会同步清理内存状态。
    }
  },
}

export default storage
